import { Navigate, Route, Routes } from "react-router-dom"
import { DataGovernorsPage } from "../pages/DataGovernorsPage/DataGovernorsPage"
import { LandingPage } from "../pages/LandingPage/LandingPage"
import { TemporaryLineManagerPage } from "../pages/TemporaryLineManagerPage/TemporaryLineManagerPage"
import { RetryRequestPage } from "../pages/RetryRequestPage/RetryRequestPage"
import { RequireAuthorizedRoute } from "../authorization/RequireAuthorizedRoute"
import { ROUTES } from "../../routes"

export interface RouterProps {
  readonly redirectAfterLoginUrl?: string | null
}

export const Router: React.FC<RouterProps> = ({ redirectAfterLoginUrl }) => (
  <Routes>
    <Route path={ROUTES.home} element={<LandingPage />} />
    <Route
      path={ROUTES.lineManager}
      element={
        <RequireAuthorizedRoute>
          <TemporaryLineManagerPage />
        </RequireAuthorizedRoute>
      }
    />
    <Route
      path={ROUTES.dataGovernors}
      element={
        <RequireAuthorizedRoute>
          <DataGovernorsPage />
        </RequireAuthorizedRoute>
      }
    />
    <Route
      path={ROUTES.retryRequest}
      element={
        <RequireAuthorizedRoute>
          <RetryRequestPage />
        </RequireAuthorizedRoute>
      }
    />
    <Route path={ROUTES.login} element={<Navigate to={redirectAfterLoginUrl ?? ROUTES.home} replace />} />
    <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
  </Routes>
)
